function initVerticalHostActivities(sectionId, blockId = null) {
  console.log("product-parts-item", sectionId, "blockId:", blockId);
  // 检查Vue是否已加载
  if (typeof window.Vue === "undefined") {
    console.warn("Vue.js 未加载，host-activities-container使用静态数据");
    return;
  }

  // 获取特定section的数据
  const allHostActivitiesData = window.hostActivitiesData || {};
  const hostActivitiesData = sectionId
    ? allHostActivitiesData[sectionId]
    : allHostActivitiesData;

  if (!hostActivitiesData) {
    console.warn("未找到section数据:", sectionId);
    return;
  }

  // 提取具体数据
  const sectionData = hostActivitiesData.section || {};
  const settings = sectionData.settings || {};
  const blocks = sectionData.blocks || [];
  console.log("Host Activities Section Data:", settings);

  // 使用更精确的容器选择器
  let containerId = `[data-section-id="${sectionId}"]`;

  // 检查容器是否存在
  let container = document.querySelector(containerId);
  if (!container) {
    console.warn(
      `Primary container not found: ${containerId}, trying fallback`
    );
    // 后备方案：使用类选择器
    containerId = `.vertical-host-activities-section`;
    container = document.querySelector(containerId);
  }

  if (!container) {
    console.error(`No suitable container found for section: ${sectionId}`);
    return;
  }
  console.log(`Found container:`, container);

  try {
    var orderSummaryApp = new window.Vue({
      delimiters: ["[[", "]]"],
      el: containerId,
      data: function () {
        // 初始化产品配件的选中状态
        const selectedProductParts = {};
        blocks.forEach((block) => {
          if (
            block.type === "product_item" &&
            block.settings.product_parts_list
          ) {
            block.settings.product_parts_list.forEach((part) => {
              // 使用 blockId-productId 作为唯一标识符  根据元数据设置默认选中状态
              selectedProductParts[`${block.id}-${part.id}`] =
                part.is_check || false;
            });
          }
        });

        return {
          sectionData: hostActivitiesData,
          settings: settings,
          blocks: blocks,
          giftCount: hostActivitiesData.gift_count || 0,
          productPartsCount: hostActivitiesData.product_parts_count || 0,
          selectedProductParts: selectedProductParts, // 存储每个产品配件的选中状态
        };
      },
      computed: {
        // 计算属性示例
        mainProduct: function () {
          // 从 product_item blocks 中获取主产品
          const productBlock = this.blocks.find(
            (block) => block.type === "product_item"
          );
          return productBlock ? productBlock.settings.product : null;
        },
        giftProducts: function () {
          const productBlock = this.blocks.find(
            (block) => block.type === "product_item"
          );
          return productBlock
            ? productBlock.settings.gift_product_list || []
            : [];
        },
        productParts: function () {
          return this.blocks.filter(
            (block) =>
              block.type === "product_item" && block.settings.product_parts_list
          );
        },
        coreFunctionImages: function () {
          return this.blocks.filter(
            (block) => block.type === "coreFunctionImg"
          );
        },
      },
      mounted: function () {
        console.log("Vue app mounted with data:", this.$data);
        this.initializeComponent();
      },
      methods: {
        initializeComponent: function () {
          // 初始化组件逻辑
          this.setupEventListeners();
        },
        setupEventListeners: function () {
          // 设置事件监听器
          console.log("Setting up event listeners...");
        },
        // 获取特定类型的块数据
        getBlocksByType: function (type) {
          return this.blocks.filter((block) => block.type === type);
        },
        // 获取产品配件数据
        getProductParts: function () {
          return this.getBlocksByType("productParts");
        },
        // 切换产品配件选中状态
        toggleProductParts: function (productId, blockId, event) {
          console.log(
            "切换产品配件项，Product ID:",
            productId,
            "Block ID:",
            blockId
          );

          // 阻止事件冒泡，避免重复触发
          if (event) {
            event.preventDefault();
          }

          const key = `${blockId}-${productId}`;
          // 使用 Vue.set 来确保响应式更新
          this.$set(
            this.selectedProductParts,
            key,
            !this.selectedProductParts[key]
          );

          // 状态改变后同步高度
          this.$nextTick(() => {
            this.syncHeights();
          });

          //   console.log("当前选中状态:", this.selectedProductParts);
          //   console.log("选中的产品数量:", this.getSelectedCount());
          //   console.log("选中的产品总价:", this.getSelectedTotal());
          console.log("选中的产品配件:", this.getSelectedProductParts());
        },
        // 获取选中的产品配件数量
        getSelectedCount: function () {
          return Object.values(this.selectedProductParts).filter(
            (selected) => selected
          ).length;
        },
        // 获取选中产品配件的总价格
        getSelectedTotal: function () {
          let total = 0;
          const selectedIds = Object.keys(this.selectedProductParts).filter(
            (id) => this.selectedProductParts[id]
          );

          selectedIds.forEach((blockId) => {
            const block = this.blocks.find((b) => b.id === blockId);
            if (
              block &&
              block.settings.product_parts &&
              block.settings.product_parts.price
            ) {
              total += block.settings.product_parts.price;
            }
          });

          return total;
        },
        // 检查某个产品配件是否被选中
        isSelected: function (blockId) {
          return this.selectedProductParts[blockId] || false;
        },
        // 获取选中的产品配件列表
        getSelectedProductParts: function () {
          const selectedKeys = Object.keys(this.selectedProductParts).filter(
            (key) => this.selectedProductParts[key]
          );

          const selectedParts = [];
          selectedKeys.forEach((key) => {
            const [blockId, productId] = key.split("-");
            const block = this.blocks.find((b) => b.id === blockId);
            if (block && block.settings.product_parts_list) {
              const part = block.settings.product_parts_list.find(
                (p) => p.id.toString() === productId
              );
              if (part && part.variants && part.variants.length > 0) {
                selectedParts.push({ id: part.variants[0].id, quantity: 1 });
              }
            }
          });

          return selectedParts;
        },
        // 获取特定block的选中配件
        getSelectedProductPartsForBlock: function (blockId) {
          if (!blockId) return this.getSelectedProductParts();

          const selectedKeys = Object.keys(this.selectedProductParts).filter(
            (key) =>
              key.startsWith(blockId + "-") && this.selectedProductParts[key]
          );

          const selectedParts = [];
          selectedKeys.forEach((key) => {
            const [bId, productId] = key.split("-");
            const block = this.blocks.find((b) => b.id === bId);
            if (block && block.settings.product_parts_list) {
              const part = block.settings.product_parts_list.find(
                (p) => p.id.toString() === productId
              );
              if (part && part.variants && part.variants.length > 0) {
                selectedParts.push({ id: part.variants[0].id, quantity: 1 });
              }
            }
          });

          return selectedParts;
        },
        // 同步高度方法
        syncHeights: function () {
          const rightContainers = document.querySelectorAll(
            `[data-section-id="${sectionId}"] .content-right`
          );
          if (rightContainers.length <= 1) return;

          // 重置高度和样式
          rightContainers.forEach((container) => {
            container.style.height = "auto";
            // 重置.right-bottom的样式
            const rightBottom = container.querySelector(".right-bottom");
            if (rightBottom) {
              rightBottom.style.position = "";
              rightBottom.style.bottom = "";
              rightBottom.style.left = "";
              rightBottom.style.right = "";
            }
          });

          this.$nextTick(() => {
            let maxHeight = 0;
            rightContainers.forEach((container) => {
              const height = container.offsetHeight;
              if (height > maxHeight) {
                maxHeight = height;
              }
            });

            if (maxHeight > 0) {
              rightContainers.forEach((container) => {
                container.style.height = `${maxHeight}px`;
                // 设置固定高度后，给.right-bottom添加绝对定位
                const rightBottom = container.querySelector(".right-bottom");
                if (rightBottom) {
                  rightBottom.style.position = "absolute";
                  rightBottom.style.bottom = "24px";
                  rightBottom.style.left = "16px";
                  rightBottom.style.right = "16px";
                }
              });
              console.log(
                `✅ Right content height sync completed: ${maxHeight}px`
              );
            }
          });
        },
        addToCart: async function (blockId = null) {
          console.log("addToCart called with blockId:", blockId);
          const itemsToAdd = [];

          // 获取指定block的主产品
          let mainProduct = null;
          if (blockId) {
            const targetBlock = this.blocks.find(
              (block) => block.id === blockId
            );
            if (targetBlock && targetBlock.settings.product) {
              mainProduct = targetBlock.settings.product;
            }
          } else {
            mainProduct = this.mainProduct;
          }

          if (
            mainProduct &&
            mainProduct.variants &&
            mainProduct.variants.length > 0
          ) {
            itemsToAdd.push({
              id: mainProduct.variants[0].id,
              quantity: 1,
            }); // 添加主商品
          }

          // 获取当前block选中的配件
          const selectedProductParts =
            this.getSelectedProductPartsForBlock(blockId);
          itemsToAdd.push(...selectedProductParts); // 添加选中的产品配件
          try {
            // 添加主商品
            const res = await fetch("/cart/add.js", {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({ items: itemsToAdd }),
            });

            if (!res.ok) {
              const contentType = res.headers.get("content-type");
              if (contentType && contentType.includes("application/json")) {
                const errorData = await res.json();
                throw new Error(errorData.description || "主商品添加失败");
              } else {
                throw new Error("请求被拦截（可能是触发了验证码或店铺未公开），请刷新页面后重试。");
              }
            }
            const data = await res.json();

            if (data.items && data.items.length > 0) {
              console.log("✅ 商品添加成功，");

              // 成功添加到购物车，打开购物车抽屉
              document.dispatchEvent(
                new CustomEvent("theme:cartchanged", {
                  bubbles: true,
                  cancelable: false,
                })
              );
              document.dispatchEvent(
                new CustomEvent("theme:open-cart-drawer", {
                  bubbles: true,
                  cancelable: false,
                })
              );
            } else {
              throw new Error("未能添加任何商品, 添加失败");
            }
          } catch (error) {
            console.error("❌ 添加到购物车失败:", error);
            alert("❌ 添加失败: " + error.message + "\n请稍后重试或联系客服。");
          }
        },
      },
    });

    // 验证Vue实例是否正确创建
    if (!orderSummaryApp.$el) {
      console.error("Vue instance failed to mount to element");
      return;
    }

    // 全局访问点 - 支持多实例
    window.orderSummaryApps = window.orderSummaryApps || {};
    const appKey = sectionId || "default";
    window.orderSummaryApps[appKey] = orderSummaryApp;

    // Vue实例挂载完成后同步高度
    orderSummaryApp.$nextTick(() => {
      orderSummaryApp.syncHeights();
    });

    // 监听窗口大小变化
    const resizeHandler = () => {
      orderSummaryApp.syncHeights();
    };
    window.addEventListener("resize", resizeHandler);

    // 存储resize处理器用于清理
    orderSummaryApp.resizeHandler = resizeHandler;

    console.log("✅ host-activities-container Vue应用初始化完成", sectionId);
    console.log("Vue instance mounted to:", orderSummaryApp.$el);
  } catch (error) {
    console.error("host-activities-container 初始化失败:", error);
  }
}

// 全局高度同步函数，可供外部调用
window.syncVerticalHostActivitiesHeights = function (sectionId) {
  if (sectionId) {
    // 同步特定section的高度
    const app = window.orderSummaryApps && window.orderSummaryApps[sectionId];
    if (app && typeof app.syncHeights === "function") {
      app.syncHeights();
      console.log(`✅ Height sync completed for section: ${sectionId}`);
    }
  } else {
    // 同步所有section的高度
    const apps = window.orderSummaryApps || {};
    Object.keys(apps).forEach((key) => {
      if (apps[key] && typeof apps[key].syncHeights === "function") {
        apps[key].syncHeights();
      }
    });
    console.log("✅ Height sync completed for all sections");
  }
};

// 导出函数供外部调用
window.initVerticalHostActivities = initVerticalHostActivities;
